"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpectrumName = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cheminfo_font_1 = require("cheminfo-font");
const styles = {
    info: {
        display: 'block',
        alignItems: 'center',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: '24px',
    },
    icon: {
        width: '16px',
        height: '16px',
        display: 'inline-block',
        verticalAlign: 'middle',
        position: 'relative',
    },
};
function SpectrumName(props) {
    return ((0, jsx_runtime_1.jsxs)("div", { style: styles.info, children: [(0, jsx_runtime_1.jsx)("div", { style: styles.icon, children: (0, jsx_runtime_1.jsx)(SpectraIcon, { ...props }) }), (0, jsx_runtime_1.jsx)("span", { children: props.data.info.name })] }));
}
exports.SpectrumName = SpectrumName;
function SpectraIcon(props) {
    const { data: { info: { isFt, isFid, dimension }, originalInfo, }, } = props;
    if (dimension === 1 && isFt && originalInfo?.isFid) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrFid, { style: { opacity: '0.3', position: 'absolute' } }), (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrFt, {})] }));
    }
    else if (dimension === 1 && isFt) {
        return (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrFt, {});
    }
    else if (isFid) {
        return (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrFid, {});
    }
    else {
        return (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmr2D, {});
    }
}
